"use client"

import { ChevronRight } from "lucide-react";
import Link from "next/link";

interface FaqLinkProps {
  id: string;
  slug: string;
  question: string;
  navigateToFaq: (id: string) => void;
}

export default function FaqLink({ id, slug, question, navigateToFaq }: FaqLinkProps) {
  return (
    <Link 
      href={`#${slug}`} 
      className="flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition duration-200"
      onClick={(e) => {
        e.preventDefault();
        navigateToFaq(id);
      }}
    >
      <span>{question}</span>
      <ChevronRight className="h-5 w-5 text-primary_green" />
    </Link>
  );
}
